import {logoData} from "./logo_data";

export function animateLogo() {
  var data = {
    container: document.getElementById("bm"),
    renderer: "svg",
    loop: false, //  => true / false / number
    autoplay: false,
    animationData: logoData,
    rendererSettings: {
      className: "b-logo-svg",
      scaleMode: "noScale"
    }
  };
  var anim = lottie.loadAnimation(data);

  var desktop = window.matchMedia("(min-width: 1024px)");

  if (desktop.matches) {
    document.getElementById("bm").addEventListener('mouseenter', function () {
      anim.goToAndPlay(0);
    });
  }

  anim.play();
}
